import { enableProdMode, importProvidersFrom } from '@angular/core';
import { enableAkitaProdMode, persistState } from '@datorama/akita';

import { environment } from './environments/environment';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { AppComponent } from '@app/app.component';
import { AppRoutingModule } from '@app/app-routing.module';
import { CoreModule } from '@app/core/core.module';
import { SharedModule } from '@app/shared/shared.module';
import { NgxCaptchaModule } from 'ngx-captcha';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { IMAGE_LOADER, ImageLoaderConfig } from '@angular/common';
import { ServiceWorkerModule } from '@angular/service-worker';

if (environment.production) {
  enableProdMode();
  enableAkitaProdMode();
}
persistState();

export function IMAGE_LOADER_PROVIDER_FACTORY(config: ImageLoaderConfig) {
  const fileUrl = config.src.split(/\.(?=[^.]+$)/);
  if (config.width === 1439) {
    fileUrl[0] += '@3x';
  } else if (config.width === 1023) {
    fileUrl[0] += '@2x';
  }
  return `${fileUrl[0]}.${fileUrl[1]}`;
}


bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      AppRoutingModule,
      CoreModule,
      SharedModule,
      NgxCaptchaModule,
      TranslateModule.forRoot(),
      ServiceWorkerModule.register('ngsw-worker.js', {
        // enabled: !isDevMode(),
        enabled: shouldEnableServiceWorker(),
        // Register the ServiceWorker as soon as the application is stable
        // or after 30 seconds (whichever comes first).
        registrationStrategy: 'registerWhenStable:30000'
      })
    ),
    provideHttpClient(
      withInterceptorsFromDi()
    ),
    provideAnimations(),
    { provide: IMAGE_LOADER, useValue: IMAGE_LOADER_PROVIDER_FACTORY },
  ]
})
  .catch(err => console.error(err));


function isRealMobileDevice(): boolean {
  const ua = navigator.userAgent || navigator.vendor;

  const isMobileUA = /android|iphone|ipad|ipod/i.test(ua);

  const isTouch = navigator.maxTouchPoints > 1;

  const isDesktopOS = /windows|macintosh|linux/i.test(ua);

  return isMobileUA && isTouch && !isDesktopOS;
}


function shouldEnableServiceWorker(): boolean {
  // Check if the user is on mobile or tablet
  const isMobileOrTablet = isRealMobileDevice();
  return isMobileOrTablet && environment.activePWA;
}
